import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from './core/header/header.component';
import { MessagesComponent } from './core/messages/messages.component';


@Component({
    selector: 'kbm-root',
    standalone: true,
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [
        RouterModule,
        HeaderComponent,
        MessagesComponent,
    ]
})
export class AppComponent  {
  title = 'kindle-manager-frontend';
}
